module.exports = __webpack_public_path__ + "img/l-hd.06cdd456.jpg";